// HOVER SECOND IMAGE MOBILE

window.onload = function hoverMobile() {
  const elements = document.querySelectorAll(".product-card__image--secondary");
  elements.forEach((element) => {
    let startY = 0;
    let hasMoved = false;

    // Add touchstart event listener
    element.addEventListener("touchstart", (e) => {
      startY = e.touches[0].clientY;
      hasMoved = false;
      element.previousElementSibling.style.opacity = 0;
      element.style.opacity = 1;
    });

    // Detectar movimiento durante el touch
    element.addEventListener("touchmove", (e) => {
      let currentY = e.touches[0].clientY;
      if (Math.abs(currentY - startY) > 5) { // Umbral de 5px para considerar movimiento
        hasMoved = true;
      }
    });

    element.addEventListener("touchend", (e) => {
      // Remove touch effect
      element.previousElementSibling.style.opacity = 1;
      element.style.opacity = 0;

      // Solo ejecutar el enlace si no hubo desplazamiento
      if (!hasMoved) {
        let parentElement = element.parentElement;
        
        if (parentElement.tagName.toLowerCase() === 'a') {
          e.preventDefault();
          setTimeout(() => {
            parentElement.click();
          }, 50);
        }
      }
    });
  });
};
